(function($) {
	$(document).ready(function() {
		$(document).foundation();

		$('.select-li').click(function() {
			var choice = $(this).text(),
				value = $(this).data('value');

			$(this).parents().find('.select-toggle .text').text(choice);
			$(this).parents().find('.select-toggle').trigger('click');
			$(this).parents().find('[data-postlist-filter]').data('value', value).trigger('datachange');
		});

		$('[data-search-trigger]').click(function() {
			$('.search-container').toggleClass('search-open');
			$('.search-container [name="s"]').focus();
		});
	});

})(jQuery);
